import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, ReqX, ZTime, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XIconButton, XText } from "IZOX/_X";
import PAContainer from "../shared/PAContainer/PAContainer";
import { QFDropUpload, QFText } from "IZOX/BLOCKS/Libs/QForm/_gears";
import { QForm } from "IZOX/BLOCKS/Libs";
import { LuEye, LuEyeOff } from "react-icons/lu";
import Styles from "__SYSDefault/Styles";
import { MdOutlineUploadFile } from "react-icons/md";
import QUICKUI from "shared/QUICKUI";
import _ from "lodash";
import VarList from "shared/VarList";

/**
 * @augments {Component<Props, State>}
 */
class PAAcountInfoW extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      tab: "contact",
      showBankAcc: false,
      editMode: false,
      contactFormValue: {},
      companyFormValue: {},
      bankFormValue: {},
      uploadBRCard: false
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.OnLoad();
      this.GetBankList();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAAcountInfoW.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }
  
  _onChange = (formValue) => {
    this.setState({
      userDoc: formValue
    });
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  OnLoad = async () => {
    await this.GetUserAccountInfo();
  }

  GetBankList = async () => {
    let docs = await VarList.GetList("Bank");
    this.setState({
      banks: docs
    });
  }

  GetUserAccountInfo = async () => {
    let res = await ReqX.SendBE("/CMS/SysUser/Self", {}, null, null);
    let {Success, payload} = res;
    if(Success){
      this.setState({
        userDoc: payload
      });
    }
  }

  _selectTab = (tab) => {
    this.setState({
      tab: tab,
      editMode: false,
      uploadBRCard: false
    });
  }

  _toggleShowBankAcc = () => {
    let {showBankAcc} = this.state;
    this.setState({
      showBankAcc: !showBankAcc
    });
  }

  _toggleUploadBR = () => {
    this.setState({
      uploadBRCard: true
    });
  }

  _toEdit = () => {
    this.setState({
      editMode: true
    });
  }

  _Cancel = () => {
    this.setState({
      editMode: false
    }, () => {
      this.GetUserAccountInfo();
    });
  }

  _Submit = async (fields) => {
    let {userDoc} = this.state;
    let res = await ReqX.SendBE("/Web/Agent/EditUserInfo", 
      {
        form: userDoc,
        fields: fields
      }
    );
    if(res.Success){
      this._Cancel();
    }else{
      GFunc.Alert(res.payload, "error");
    }
  }

  _validate = () => {
    let {userDoc} = this.state;
    let valid = true;
    valid = ZValidate.CheckAllFields(userDoc, 
      [
        "meta.fullName.EN", 
        "email", 
        "telNo",
        "meta.agencyCode",
        "meta.companyName.EN",
        "meta.companyName.TC",
        "meta.companyAddress.EN",
        "meta.companyAddress.TC",
        "meta.companyEmail",
        "meta.companyBRNo",
        "meta.officeNo",
        "meta.companyFax",
        "meta.bankPayee",
        "meta.bankID",
        "meta.bankACNo"
      ], "required");
    if(!valid) return false;
    return true;
  }

  _SubmitContact = async () => {
    this._Submit([
      "meta.fullName.EN",
      "telNo",
      "email",
      "meta.agencyCode"
    ]);
  }

  _SubmitCompany = async () => {
    this._Submit([
      "meta.companyName.EN",
      "meta.companyName.TC",
      "meta.companyAddress.EN",
      "meta.companyAddress.TC",
      "meta.companyEmail",
      "meta.companyBRNo",
      "meta.officeNo",
      "meta.companyFax",
      "meta.companyBRAtth"
    ]);
  }

  _SubmitBank = async () => {
    this._Submit([
      "meta.bankPayee",
      "meta.bankID",
      "meta.bankACNo"
    ]);
  }

  renderPageTab(_tab, label){
    let {tab} = this.state;
    let isSelected = tab === _tab;
    return (
      <XButton onPress={() => this._selectTab(_tab)} round={0}
        padding={16}
        fullWidth
        bgColor={ColorX.CSS(isSelected ? "DeepBlueSea" : "Gray4")} color={ColorX.CSS("pureWhite")}>
        <HStack>
          <XText bold fontSize={14}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderPageSelector(){
    return (
      <HStack spacing={5} pB={24} pH={16}>
        {this.renderPageTab("contact", {
          EN: "Contact Person",
          TC: "聯絡人"
        })}
        {this.renderPageTab("company", {
          EN: "Company",
          TC: "公司"
        })}
        {this.renderPageTab("bank", {
          EN: "Bank Information",
          TC: "銀行資料"
        })}
      </HStack>
    );
  }

  renderField(label, value, inject = null){
    return (
      <VStack fullWidth p={16}>
        <HStack HAlign="[" pV={8}>
          <XText fontSize={12} color={ColorX.CSS("Gray4")}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <HStack HAlign="[">
          <XText fontSize={14}>
            {value}
          </XText>
          <Spacer/>
          {inject}
        </HStack>
      </VStack>
    );
  }

  renderLastUpdate(){
    let {userDoc} = this.state;
    let {lastModifiedAt} = userDoc ?? {};
    return (
      <HStack pV={16}>
        <XText color={ColorX.CSS("Stone")} fontSize={12}>
          {LocaleX.Parse({
            EN: "Last updated ",
            TC: "最後更新 "
          }) + (lastModifiedAt ?
            ZTime.Moment(lastModifiedAt).format("LLL") : "NULL")}
        </XText>
      </HStack>
    );
  }

  renderContact(){
    let {userDoc} = this.state;
    let {meta, telNo, email} = userDoc ?? {};
    let {fullName, disHKID, agencyCode} = meta ?? {};
    return (
      <VStack fullWidth height={600} pH={16}>
        <VStack fullWidth bgColor={ColorX.CSS("pureWhite")}>
          <HStack>
            {this.renderField({
              EN: "Agent code",
              TC: "代理號碼"
            }, agencyCode ?? "NULL")}
          </HStack>
          <HStack>
            {this.renderField({
              EN: "Full name (English)",
              TC: "全名 (英文)"
            }, fullName?.EN ?? "NULL")}
            {this.renderField({
              EN: "HKID",
              TC: "香港身分證"
            }, disHKID ?? "NULL")}
          </HStack>
          <HStack>
            {this.renderField({
              EN: "Phone number",
              TC: "全名 (英文)"
            }, `+852 ${telNo ?? "----"}`)}
            {this.renderField({
              EN: "Email",
              TC: "電郵"
            }, email ?? "NULL")}
          </HStack>
        </VStack>
        {this.renderLastUpdate()}
        <XButton onPress={this._toEdit}
          bgColor={ColorX.CSS("Axit")} color={ColorX.CSS("pureWhite")}
          round={50} width={242} padding={0} pH={25} pV={5}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Update",
                TC: "更新"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderCompany(){
    let {userDoc} = this.state;
    let {meta} = userDoc ?? {};
    let {companyName,
      companyEmail, companyBRNo, officeNo, companyFax, 
      companyAddress} = meta ?? {};
    return (
      <VStack fullWidth pB={50} pH={16}>
        <VStack fullWidth bgColor={ColorX.CSS("pureWhite")}>
          <HStack>
            {this.renderField({
              EN: "Company's name (English)",
              TC: "公司名稱 (英文)"
            }, companyName?.EN ?? "NULL")}
            {this.renderField({
              EN: "Company's name (Chinese)",
              TC: "公司名稱 (中文)"
            }, companyName?.TC ?? "NULL")}
          </HStack>
          <HStack>
            {this.renderField({
              EN: "Company Address (English)",
              TC: "公司地址 (英文)"
            }, companyAddress?.EN ?? "NULL")}
          </HStack>
          <HStack>
            {this.renderField({
              EN: "Company Address (Chinese)",
              TC: "公司地址 (中文)"
            }, companyAddress?.TC ?? "NULL")}
          </HStack>
          <HStack>
            {this.renderField({
              EN: "Company email",
              TC: "公司信電郵"
            }, companyEmail)}
            {this.renderField({
              EN: "BR number",
              TC: "商業登記號碼"
            }, companyBRNo)}
          </HStack>
          <HStack>
            {this.renderField({
              EN: "Office number",
              TC: "辦公室號碼"
            }, officeNo)}
            {this.renderField({
              EN: "Contact Fax",
              TC: "聯絡傳真"
            }, companyFax)}
          </HStack>
          <HStack HAlign="[" pH={16}>
            <XText fontSize={12} color={ColorX.CSS("Gray4")}>
              {LocaleX.Parse({
                EN: "BR Card",
                TC: "商業登記卡"
              })}
            </XText>
          </HStack>
          <QFDropUpload
            fileSizeLimit={10}
            accept=".jpg,.png,.pdf,.jpeg"
            fullWidth
            readOnly
            instantUpload
            name="meta.companyBRAtth"
            noFileCaption
            previewZoneProps={{
              width: "100%",
              pB: 30,
              pH: 16
            }}
            />
          <HStack HAlign="[" pH={16}>
            <XText fontSize={12} color={ColorX.CSS("Gray4")}>
              {LocaleX.Parse({
                EN: "Employment Agency License",
                TC: "職業代理執照 (Employment Agency License)"
              })}
            </XText>
          </HStack>
          <QFDropUpload
            fileSizeLimit={10}
            accept=".jpg,.png,.pdf,.jpeg"
            fullWidth
            readOnly
            instantUpload
            name="meta.companyEALAtth"
            noFileCaption
            previewZoneProps={{
              width: "100%",
              pB: 30,
              pH: 16
            }}
            />
        </VStack>
        {this.renderLastUpdate()}
        <XButton onPress={this._toEdit}
          bgColor={ColorX.CSS("Axit")} color={ColorX.CSS("pureWhite")}
          round={50} width={242} padding={0} pH={25} pV={5}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Update",
                TC: "更新"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderBank(){
    let {userDoc, showBankAcc, banks} = this.state;
    let {meta} = userDoc ?? {};
    let {bankACNo, bankID, bankPayee} = meta ?? {};
    let _bank = _.find(banks, o => o._id === bankID);
    return (
      <VStack fullWidth minHeight={600} pH={16}>
        <VStack fullWidth bgColor={ColorX.CSS("pureWhite")}>
          <HStack>
            {this.renderField({
              EN: "Payee",
              TC: "收款人"
            }, bankPayee ?? "NULL")}
            {this.renderField({
              EN: "Bank",
              TC: "銀行"
            }, LocaleX.Parse(_bank?.name))}
            {this.renderField({
              EN: "Bank account number",
              TC: "銀行帳號"
            }, (showBankAcc ? bankACNo : "--- ------ ---") ?? "NULL",
            <XIconButton onPress={this._toggleShowBankAcc} padding={0}>
              {showBankAcc ? <LuEye color={ColorX.CSS("Gray4")}/> 
              : <LuEyeOff color={ColorX.CSS("Gray4")} />}
            </XIconButton>)}
          </HStack>
        </VStack>
        {this.renderLastUpdate()}
        <XButton onPress={this._toEdit}
          bgColor={ColorX.CSS("Axit")} color={ColorX.CSS("pureWhite")}
          round={50} width={242} padding={0} pH={25} pV={5}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Update",
                TC: "更新"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderButton(backFunc, nextFunc, 
    backCap = { EN: "Close", TC: "關閉" },
    nextCap = { EN: "Next", TC: "下一步"},
    validFunc = null){
    return (
      <HStack spacing={16} 
        style={{
          borderTopWidth: 1, 
          borderTopStyle: "solid",
          borderTopColor: ColorX.CSS("greyOut", 0.3)
        }} 
        HAlign="]" p={16}>
        <XButton fitWidthToContent onPress={backFunc}
          color={ColorX.CSS("Axit")}>
          <HStack>
            <XText bold>
              {LocaleX.Parse(backCap)}
            </XText>
          </HStack>
        </XButton>
        <XButton {...Styles.QFBtn} width={200} onPress={nextFunc}
          disabled={!validFunc?.()}
          padding={0} pV={8}>
          <HStack>
            <XText bold>
              {LocaleX.Parse(nextCap)}
            </XText>
          </HStack>
        </XButton>
      </HStack>
    );
  }

  renderTextField(name, label, starred, readOnly = false, width = 374, others = {}){
    return (
      <VStack width={width}>
        <HStack HAlign="[" spacing={4}>
          <XText fontSize={12} color={ColorX.CSS("Stone")}>
            {LocaleX.Parse(label)}
          </XText>
          {starred &&
            <XText fontSize={12} color={ColorX.CSS("Blood")}>{"*"}</XText>}
        </HStack>
        <QFText name={name} placeholder={LocaleX.Parse(label)} 
          readOnly={readOnly}
          p={12}
          focus_bColor={ColorX.CSS("Axit")}
          bColor={ColorX.CSS("Gray5")}
          {...others}/>
      </VStack>
    );
  }

  renderEditContact(){
    return (
      <VStack fullWidth height={600} pH={16}>
        <VStack fullWidth bgColor={ColorX.CSS("pureWhite")} pV={16}
          spacing={16}>
          <HStack spacing={16} pH={16}>
            {QUICKUI.WebTextField("meta.fullName.EN", {
              EN: "Full name (English)",
              TC: "全名 (英文)"
            }, {width: "50%"})}
          </HStack>
          <HStack spacing={16} pH={16}>
            <VStack width={"50%"}>
              <HStack HAlign="[" spacing={5} fullWidth>
                <XText fontSize={12}>
                  {LocaleX.Parse({
                    EN: "Mobile phone",
                    TC: "手機號碼"
                  })}
                </XText>
                <XText fontSize={12} color={ColorX.CSS("Blood")}>{"*"}</XText>
              </HStack>
              <HStack spacing={8}>
                <QFText 
                  {...Styles.QFText}
                  name="zip"
                  textAlign="|"
                  width={104}
                  defaultValue={"+852"}
                  disabled_bgColor={ColorX.CSS("Gray5")}
                  readOnly/>
                <QFText fontSize={14} p={12}
                  {...Styles.QFText}
                  bColor={ColorX.CSS("Gray5")}
                  focus_bColor={ColorX.CSS("Axit")}
                  name="telNo"
                  width={100}
                  bW={1}
                  placeholder={LocaleX.Parse({
                    EN: "Enter your mobile phone no.",
                    TC: "輸入你的電話號碼"
                  })}
                  fullWidth/>
              </HStack>
            </VStack>
            {QUICKUI.WebTextField("email", {
              EN: "Email",
              TC: "電郵"
            }, {width: "50%"})}
          </HStack>
          <HStack HAlign="[" pH={16}>
            {QUICKUI.WebTextField("meta.agencyCode",
            {
              EN: "Agent code",
              TC: "代理號碼"
            }, {width: "49%", readOnly: true})}
          </HStack>
        </VStack>
        {this.renderLastUpdate()}
        {this.renderButton(this._Cancel, this._SubmitContact, 
          {
            EN: "Cancel",
            TC: "取消"
          }, 
          {
            EN: "Save",
            TC: "儲存"
          }, this._validate)}
      </VStack>
    );
  }

  renderEditCompany(){
    let {uploadBRCard} = this.state;
    return (
      <VStack fullWidth pH={16}>
        <VStack fullWidth bgColor={ColorX.CSS("pureWhite")} pV={16}
          spacing={16}>
          <HStack spacing={16} pH={16}>
            {QUICKUI.WebTextField("meta.companyName.EN", {
              EN: "Company's name (English)",
              TC: "公司名稱 (英文)"
            }, {width: "50%"})}
            {QUICKUI.WebTextField("meta.companyName.TC", {
              EN: "Company's name (Chinese)",
              TC: "公司名稱 (中文)"
            }, {width: "50%"})}
          </HStack>
          <HStack spacing={16} pH={16}>
            {QUICKUI.WebTextField("meta.companyAddress.EN", {
              EN: "Company Address (English)",
              TC: "公司地址 (英文)"
            }, { width: "100%" })}
          </HStack>
          <HStack spacing={16} pH={16}>
            {QUICKUI.WebTextField("meta.companyAddress.TC", {
              EN: "Company Address (Chinese)",
              TC: "公司地址 (中文)"
            }, { width: "100%" })}
          </HStack>
          <HStack spacing={16} pH={16}>
            {QUICKUI.WebTextField("meta.companyEmail", {
              EN: "Company email",
              TC: "公司信電郵"
            }, {width: "50%"})}
            {QUICKUI.WebTextField("meta.companyBRNo", {
              EN: "BR number",
              TC: "商業登記號碼"
            }, {width: "50%"})}
          </HStack>
          <HStack spacing={16} pH={16}>
            {QUICKUI.WebTextField("meta.officeNo", {
              EN: "Office number",
              TC: "辦公室號碼"
            }, {width: "50%"})}
            {QUICKUI.WebTextField("meta.companyFax", {
              EN: "Contact Fax",
              TC: "聯絡傳真"
            }, {width: "50%"})}
          </HStack>
          <HStack HAlign="[" pH={24}>
            <XText fontSize={12} color={ColorX.CSS("Gray3")}>
              {LocaleX.Parse({
                EN: "BR Card",
                TC: "商業登記卡"
              })}
            </XText>
            <Spacer/>
            {!uploadBRCard &&
              <XButton onPress={this._toggleUploadBR}
                color={ColorX.CSS("Axit")}>
                <HStack>
                  <MdOutlineUploadFile/>
                  <XText fontSize={12}>
                    {LocaleX.Parse({
                      EN: "Update BR Card",
                      TC: "更新商業登記卡"
                    })}
                  </XText>
                </HStack>
              </XButton>}
          </HStack>
          <HStack pH={24}>
            <QFDropUpload
              fileSizeLimit={10}
              accept=".jpg,.png,.pdf,.jpeg"
              fullWidth
              readOnly={!uploadBRCard}
              instantUpload
              name="meta.companyBRAtth"
              noFileCaption
              previewZoneProps={{
                width: "100%",
                pB: 30
              }}
              />
          </HStack>
        </VStack>
        {this.renderLastUpdate()}
        {this.renderButton(this._Cancel, this._SubmitCompany, 
          {
            EN: "Cancel",
            TC: "取消"
          }, 
          {
            EN: "Save",
            TC: "儲存"
          }, this._validate)}
      </VStack>
    );
  }

  renderEditBank(){
    let {banks} = this.state;
    return (
      <VStack fullWidth height={600} pH={16}>
        <VStack fullWidth bgColor={ColorX.CSS("pureWhite")} pV={16}
          spacing={16}>
          <HStack spacing={16} pH={16}>
            {QUICKUI.WebTextField("meta.bankPayee", {
              EN: "Payee",
              TC: "收款人"
            }, {width: "50%"})}
            {QUICKUI.WebDropdown("meta.bankID", {
              EN: "Bank",
              TC: "銀行"
            }, banks, {width: "50%", valAccessor: "_id", capAccessor: "name"})}
            {QUICKUI.WebTextField("meta.bankACNo", {
              EN: "Bank account number",
              TC: "銀行帳號"
            }, {width: "50%"})}
          </HStack>
        </VStack>
        {this.renderLastUpdate()}
          {this.renderButton(this._Cancel, this._SubmitBank, 
          {
            EN: "Cancel",
            TC: "取消"
          }, 
          {
            EN: "Save",
            TC: "儲存"
          }, this._validate)}
      </VStack>
    );
  }

  renderMain(){
    let {tab, editMode} = this.state;
    if(editMode){
      switch(tab){
        default: case "contact": return this.renderEditContact();
        case "company": return this.renderEditCompany();
        case "bank": return this.renderEditBank();
      }
    }

    switch(tab){
      default: case "contact": return this.renderContact();
      case "company": return this.renderCompany();
      case "bank": return this.renderBank();
    }
  }

  render(){
    let {userDoc} = this.state;
    return (
      <PAContainer>
        <VStack fullWidth bgColor={ColorX.CSS("NotQuiteWhite")}>
          <HStack HAlign="[" pV={16} pH={16}>
            <XText bold color={ColorX.CSS("Leaf")}>
              {LocaleX.Parse({
                EN: "Account Information",
                TC: "帳號資料"
              })}
            </XText>
          </HStack>
          {this.renderPageSelector()}
          <QForm value={userDoc} fullWidth onChange={this._onChange}>
            {userDoc && this.renderMain()}
          </QForm>
        </VStack>
      </PAContainer>
    );
  }

}

export default observer(PAAcountInfoW);
